export default "__VITE_ASSET__B3Zpvk1X__"